/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import { ATTRIBUTE_EXCLUSION_LIST } from "../../../utility/constants";

const attributeCategories = {
	general: "general",
	hidden: "hidden",
};

/**
 * Get value by attribute name, or return default
 * @param {Array} attributes
 * @param {string} name
 * @param {any} defaultValue
 */
export const getAttributeValueByName = (attributes, name, defaultValue = null) => {
	const attr = attributes.find((a) => a.name === name);
	return attr?.value || defaultValue;
};

/**
 * This method takes in a list of attributes and organizes them
 * by type and if they have an index.
 */
export const organizeAttributes = (attributes) => {
	let attributeDictionary = {
		[attributeCategories.general]: [],
	};

	attributes.forEach((attribute) => {
		try {
			const prefix = attribute.name.substring(0, attribute.name.indexOf("_")).toLowerCase();
			const name = prefix ? attribute.name.substring(prefix.length + 1) : attribute.name;

			const matchOrder = prefix?.match(/\d+/g);
			const order = matchOrder ? Number(matchOrder[matchOrder.length - 1]) : -1;
			let category = attribute.name.substring(0, attribute.name.search(/\d*_/)).toLowerCase() || null;

			if (!category || ATTRIBUTE_EXCLUSION_LIST[attribute.name]) {
				return;
			}

			if (!attributeDictionary[category]) {
				attributeDictionary[category] = [];
			}

			attributeDictionary[category].push({
				id: attribute.name,
				value: attribute.value,
				prefix,
				name,
				order,
			});
		} catch (error) {}
	});
	Object.values(attributeDictionary).forEach((value) => {
		value.sort((a, b) => {
			if (a.order === -1) return 1;
			if (b.order === -1) return -1;
			if (a.order < b.order) return -1;
			if (a.order > b.order) return 1;
			if (a.name < b.name) return -1;
			if (a.name > b.name) return 1;
			return 0;
		});
	});

	return attributeDictionary;
};
